import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat, YoutubeFormatHelper } from '../../../../../../../utils/youtube-format-helper';
import { DiscoverMobileHeaderComponent } from '../../../preview-common/discover/discover-mobile-header/discover-mobile-header.component';
import { MobileFrameComponent } from '../../../preview-common/mobile-frame/mobile-frame.component';

/**
 * Video ad in the Google Discover feed: the same sponsored card as the single
 * image placement, but the creative slot plays instead of sitting still — hence
 * the play glyph and the elapsed-time badge. The 16:9 placement.
 */
@Component({
    selector: 'app-gen-discover-ad-mobile',
    imports: [CommonModule, MobileFrameComponent, DiscoverMobileHeaderComponent],
    templateUrl: './discover-ad-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: [
        '../../../preview-common/discover/discover-mobile-styles.scss',
        './discover-ad-mobile.component.scss',
    ]
})
export class DiscoverAdMobilePreviewComponent {
  @Input() data!: GenVideoPreviewData;

  /** The creative format this placement previews, found by measured ratio. */
  readonly format: VideoFormat = '16:9';

  /** Thumbnail of the 16:9 video, or '' when there isn't one yet. */
  get thumbnailUrl(): string {
    return YoutubeFormatHelper.thumbnailForFormat(this.videoIds, this.format);
  }

  /**
   * True while any link is still being measured, so the empty slot says so
   * rather than asking for a video that is about to turn up.
   */
  get isResolving(): boolean {
    return YoutubeFormatHelper.isResolvingAny(this.videoIds);
  }

  /**
   * The card's text runs headline and description together over three lines,
   * so the headline takes the long one and only falls back to the short one
   * when there isn't one.
   */
  get headline(): string {
    return this.data.longHeadlines[0] || this.data.headlines[0] || 'Your headline appears here';
  }

  private get videoIds(): string[] {
    return this.data.videos.map((video) => video.videoId);
  }
}
